import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

interface BrandPositioningProps {
  onNavigate: (id: string) => void;
}

export default function BrandPositioning({ onNavigate }: BrandPositioningProps) {
  const { ref: textRef, isVisible: textVisible } = useScrollAnimation<HTMLDivElement>();

  return (
    <section className="flex flex-col lg:flex-row min-h-[400px] lg:min-h-[600px]">
      {/* Left – Image */}
      <div className="w-full lg:w-1/2 h-64 sm:h-80 lg:h-auto lg:min-h-[500px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_7228d87fcc94d26d44be8c2a4b468347_80e83ed7.jpg"
          alt="Luxury jewelry lifestyle"
          className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-1000"
        />
      </div>

      {/* Right – Content */}
      <div className="w-full lg:w-1/2 bg-[#E8DFD0] flex items-center justify-center py-16 sm:py-20 lg:py-24 px-6 sm:px-10 lg:px-20">
        <div
          ref={textRef}
          className={`max-w-lg transition-all duration-1000 ${
            textVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"
          }`}
        >
          <p
            className="text-[#B76E79] text-[11px] uppercase tracking-[4px] mb-6 sm:mb-8"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            Philosophy
          </p>
          <h2
            className="text-[#6B4423] text-3xl sm:text-4xl md:text-5xl leading-tight mb-8 sm:mb-10"
            style={{ fontFamily: "Playfair Display, serif", fontWeight: 500 }}
          >
            Luxury in Its Purest Form
          </h2>
          <div
            className="text-[#6B5D4F] text-base sm:text-lg leading-relaxed space-y-4 sm:space-y-5"
            style={{ fontFamily: "Inter, sans-serif", fontWeight: 300 }}
          >
            <p>
              Rustic Copper is not about trends.
              It is about permanence.
            </p>
            <p>
              We design pieces that evolve with you and tell your story — each
              one unique, each one irreplaceable.
            </p>
          </div>
          <div className="flex items-center gap-5 mt-10 sm:mt-12">
            <div className="w-10 h-px bg-[#B76E79]" />
            <button
              onClick={() => onNavigate("custom")}
              className="text-[11px] uppercase tracking-[2px] text-[#B76E79] hover:text-[#6B4423] transition-colors duration-300 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "Inter, sans-serif" }}
            >
              Discover the Collection
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
